import { useContext, useMemo } from 'react';

import { ThemeContext } from '../../theme/context/ThemeContext';
import { PopoverPartialTheme, PopoverTheme } from '../types';

import { popover_theme } from './constants';

export const usePopoverTheme = (
  theme: Partial<PopoverPartialTheme> = popover_theme
): PopoverTheme => {
  const {
    theme: {
      popover: { background, color, border, general },
    },
  } = useContext(ThemeContext);

  return useMemo(
    () => ({
      background: { ...background, ...theme.background },
      color: { ...color, ...theme.color },
      border: { ...border, ...theme.border },
      general: { ...general, ...theme.general },
    }),
    [background, general, color, border, theme]
  );
};
